import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function CandidateAssignModal({ candidateId, employees, onClose, onAssigned }) {
  const [assignTo, setAssignTo] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!assignTo) return;
    setBusy(true);
    try {
      await api.post("/assignments", { candidate_id: candidateId, employee_id: assignTo });
      toast.success("Assigned");
      onAssigned?.();
      onClose();
    } catch (ex) {
      toast.error(formatApiError(ex.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm grid place-items-center p-4 z-50">
      <div className="bg-white rounded-xl border border-slate-200 p-6 w-full max-w-md">
        <h3 className="font-semibold mb-3">Assign Candidate</h3>
        <select
          value={assignTo}
          onChange={(e) => setAssignTo(e.target.value)}
          data-testid="assign-select"
          className="w-full border border-slate-200 rounded-md px-3 py-2 text-sm mb-4"
        >
          <option value="">Select executive…</option>
          {employees.map((e) => (
            <option key={e.id} value={e.id}>
              {e.name} ({e.team || "—"})
            </option>
          ))}
        </select>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm rounded-md border border-slate-200">
            Cancel
          </button>
          <button
            onClick={submit}
            disabled={!assignTo || busy}
            data-testid="assign-submit"
            className="px-4 py-2 text-sm rounded-md bg-sky-600 hover:bg-sky-700 text-white disabled:opacity-50"
          >
            {busy ? "Assigning…" : "Assign"}
          </button>
        </div>
      </div>
    </div>
  );
}
